// extracted by mini-css-extract-plugin
export default {"card":"CharacterCard_card__QHLK4","info":"CharacterCard_info__vx4ig","button":"CharacterCard_button__9T3kG"};